import { render, staticRenderFns } from "./WriteActionButton.vue?vue&type=template&id=3aeb8788&scoped=true&"
import script from "./WriteActionButton.vue?vue&type=script&lang=ts&"
export * from "./WriteActionButton.vue?vue&type=script&lang=ts&"
import style0 from "./WriteActionButton.vue?vue&type=style&index=0&id=3aeb8788&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aeb8788",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VBtn,VCard,VCardText,VMenu})
